
import TSSchadenfallDTO from './TSSchadenfallDTO';
export default class TSSchadenfaelleSearchresultDTO {

    private _schadenfallDTOs: Array<TSSchadenfallDTO> = [];
    private _totalResultSize: number = 0;


    public get schadenfallDTOs(): Array<TSSchadenfallDTO> {
        return this._schadenfallDTOs;
    }

    public set schadenfallDTOs(value: Array<TSSchadenfallDTO>) {
        this._schadenfallDTOs = value;
    }

    get totalResultSize(): number {
        return this._totalResultSize;
    }

    set totalResultSize(value: number) {
        this._totalResultSize = value;
    }


    public parseSchadenfallDTOs(data: any): TSSchadenfallDTO[] {
        let pendenzen: TSSchadenfallDTO[] = [];
        if (data && Array.isArray(data)) {
            for (let i = 0; i < data.length; i++) {
                pendenzen[i] = new TSSchadenfallDTO().deserialize(data[i]);
            }
        } else {
            pendenzen[0] = new TSSchadenfallDTO().deserialize(data);
        }
        return pendenzen;
    }

    deserialize(restObject: any): TSSchadenfaelleSearchresultDTO {

        this.schadenfallDTOs = this.parseSchadenfallDTOs(restObject.schadenfallDTOs);
        this.totalResultSize = restObject.paginationDTO.totalItemCount;
        return this;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSSchadenfaelleSearchresultDTO.ts